import { Navigate, NavLink } from 'react-router-dom';
import useAuth from '@/features/hooks/useAuth';
import useMenu from '@/features/hooks/useMenu';
import { renderIcon } from '@/utils/iconRenderer';
import { t } from 'i18next';

export default function Sidebar({ isSidebarOpen, toggleSidebar }) {
  const { isAuthenticated, user } = useAuth();
  const { currentMenus, selectedComponentHandler } = useMenu();

  // Sidebar için geçerli menü öğelerini filtreleyin
  const sidebarMenuItems = currentMenus.filter((item) => item.isSidebarMenu && item.isShowMenu);

  // Eğer kullanıcı oturum açmamışsa giriş sayfasına yönlendir
  if (!isAuthenticated) {
    return <Navigate to="/auth/login" />;
  }

  function navClickHandler(e) {
    toggleSidebar(); // Sidebar'ı kapat
    selectedComponentHandler(e.currentTarget.value);
  }

  return (
    <>
      {/* Sidebar Gölgeli Arkaplan */}
      <div
        className={`fixed inset-0 bg-gray-900 bg-opacity-50 ${isSidebarOpen ? 'block' : 'hidden'
          }`}
        onClick={toggleSidebar}
      ></div>

      {/* Sidebar Menüsü */}
      <div
        className={`fixed top-0 left-0 h-full w-[75%] max-w-xs bg-white border-r border-gray-300 shadow-lg transform transition-transform duration-300 ease-in-out ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
          } z-sidebar`}
      >
        <nav id="sidebar" className="p-0">
          {/* Kullanıcı Profili */}
          <div className="sidebar-header flex flex-col items-center text-center mb-2 border-b border-gray-200 bg-color-secondary">
            <img
              src={user?.image || "/images/avatar/UserNull.png"}
              alt=""
              className="w-20 h-20 rounded-full shadow-md scale-75 border-1 bg-gray-300 border-gray-300"
            />
            <p className="text-sm font-normal text-gray-100 mb-2">
              {user?.fullName || '..'}
            </p>
          </div>

          {/* Menü Öğeleri */}
          <ul className="list-unstyled">
            {sidebarMenuItems.map((menu) => (
              <li key={menu.id} className="mb-2">
                <NavLink
                  to={menu.to}
                  value={menu.id}
                  className="flex items-center p-1 ml-2 text-gray-500 rounded-md transition-colors duration-200 hover:bg-color-hover hover:text-gray-900 gap-3 border-b border-gray-200"
                  onClick={navClickHandler}
                >
                  {renderIcon(menu.icon, 20, 'text-gray-500')}
                  <span className="text-sm font-light">{t(menu.name)}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        {/* Sidebar Kapatma Butonu */}
        <button
          onClick={toggleSidebar}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
        >
          {renderIcon('close', 18, "text-gray-200")}
        </button>
      </div>
    </>
  );
}
